import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const radarChartDescription: CalculatorDescription = {
  id: CalculatorId.RadarChart,
  title: 'Radar Chart',
  metaTitle: 'Free Online Radar Chart Maker - Create Spider/Web Charts',
  description: 'Create radar charts (also known as spider or web charts) to visualize multivariate data and compare multiple variables across different categories. Perfect for performance analysis, skill assessments, and feature comparisons.',
  metaDescription: 'Create professional radar charts online for free. Compare multiple variables, analyze performance metrics, and visualize data patterns with our easy-to-use radar chart maker.',
  howTo: {
    title: 'How to Create a Radar Chart',
    steps: [
      'Upload or enter your data with categories and corresponding values',
      'Select the category column that defines the axes of your radar chart',
      'Choose one or more value columns to plot on the radar chart',
      'Customize the appearance by adjusting the axis maximum and area settings',
      'Add a title to your chart to describe what it represents',
      'Your radar chart will update automatically as you make changes'
    ]
  },
  examples: [
    {
      title: 'Employee Skills Assessment',
      description: 'Comparing skills and competencies across different employees',
      dataDescription: 'Multiple employees rated across various skill categories',
      insights: [
        'Easily identify strengths and areas for improvement',
        'Compare performance across different skill dimensions',
        'Spot skill gaps in the team',
        'Track development progress over time'
      ]
    },
    {
      title: 'Product Comparison',
      description: 'Comparing features and specifications of different products',
      dataDescription: 'Multiple products rated across various features',
      insights: [
        'Visualize product strengths and weaknesses',
        'Compare multiple products simultaneously',
        'Identify competitive advantages',
        'Make informed purchase decisions'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.ScatterChart,
    CalculatorId.BarGraph,
    CalculatorId.LineChart
  ]
}; 